import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=566f7c02&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=ts&"
export * from "./Login.vue?vue&type=script&lang=ts&"
import style0 from "./Login.vue?vue&type=style&index=0&id=566f7c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f7c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src141814727/src/web-authentication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566f7c02')) {
      api.createRecord('566f7c02', component.options)
    } else {
      api.reload('566f7c02', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=566f7c02&scoped=true&", function () {
      api.rerender('566f7c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/authentication/Login.vue"
export default component.exports